var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("default", null, {
        isRequestContractorShown: _vm.isRequestContractorShown,
        changeRequestStatus: _vm.changeRequestStatus,
        isAccessGranted: _vm.isAccessGranted,
        isContractorRequested: _vm.isContractorRequested,
        contractorId: _vm.contractorId,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }